export const breakpoints = {
  /** mobile: da 0 a 767px */
  /** tablet: da 768px a 1151px */
  tablet: 768,
  /** desktop: da 1152px */
  desktop: 1152,
  /** desktop wide: da 1366px */
  desktopWide: 1366,
};

export const calculateDevice = (d: number) => {
  switch (true) {
    case d >= breakpoints.desktopWide:
      return "desktop-wide";
    case d >= breakpoints.desktop:
      return "desktop";
    case d >= breakpoints.tablet:
      return "tablet";
    default:
      return "mobile";
  }
};

export enum DeviceEnum {
  mobile = "mobile",
  tablet = "tablet",
  desktop = "desktop",
  desktopWide = "desktop-wide",
}
